export default "__VITE_ASSET__DTd8P0B0__"